import axios from 'axios';
import env from '../config/env';
export const GET_COLLECTION = 'GET_COLLECTION';
export const POST_MESSAGE = 'POST_MESSAGE';

export function getCollection(collection) {
	const request = axios.get(`${env.app_url}/api/collections/get/${collection}?token=${env.token}`);

	return {
		type: GET_COLLECTION,
		payload: request
	};
}

export function sendMessage(collection) {
	const request = axios.get(`${env.url}/contact.php`);

	return {
		type: POST_MESSAGE,
		payload: request
	};
}



// WEBPACK FOOTER //
// ./src/actions/index.js